import React from "react";
import {
  //Error404,
  Home,
  Kudamulukku2017ThanksNote,
  CalendarEvents,
  AdminCalendar,
  Login,
  LoginAwaitingLink,
  SignUpVerify,
  PasswordVerify,
  //FirebaseActionRedirect,
  Logout,

  VelalarKudiyetram,
  Kongunadu,
  Arayanadu,
  Kanjimanadhi,
  VithariAthipalayam,
  Ponnachiamman,
  PonnachiammanTempleAndFunction,
  SembuthanKulam,
  SembuthanKulamKaneyurgal,
  KonguAvanangalilSembuthankulam,
  SembuthanKulamKalvettukal,
  SembuthanKulaManikki,
  PugalpadiyaPulavargal,
  Kulakurukkal,
  PonnachiAmmanUnjalPattu,
  SattrukaviValthupa,
  PonnachiammanPugalmalai,

  UserProfileHome,
  UserInbox,
  UserDonations,
  UserFamily,
  UserProfileSetPassword,
  //UserAddressUpdate,
  UserMobileVerification,
  UserFamilyAddressUpdate,
  UserFamilyCreate,
  UserFamilyUpdate,
  UserFamilyView,

  UserFamilyMemberCreate,
  UserFamilyMemberUpdate,
  UserFamilyMemberView,


  AddressAdmin,
  AddressAreaCreate,
  AddressAreaUpdate,
  AddressSubAreaUpdate,
  AddressAreaView,

  FamilyAdmin,
  FamilyAddressUpdate,
  FamilyCreate,
  FamilyUpdate,
  FamilyView,
  FamilyActivate,

  FamilyMemberCreate,
  FamilyMemberActivate,
  BulkMoveFamilyMembers,
  FamilyMemberUpdate,
  FamilyMemberView,

  ContactUs,
  PrivacyPolicy,

  GenerateQRCode,

  CategoryAdmin,

  DonationAdmin,
  DonationCreate,
  EventDonationCreate,
  DonationView,

  ExpensesAdmin,
  ExpenseCreate,
  ExpenseView,
  ExpensesSearch,

  ContactAdmin,
  BulkSmsSend,
  BulkSmsDeliveryCheck,
  BulkMobileStatusUpdate,

} from "../pages/route";

const routesConfig = [
  { path: "/", element: <Home />, breadcrumb: "முகப்பு" },

  { path: "/auth", element: <Login />, breadcrumb: "அங்கிகரித்தல்" },
  { path: "/auth/login", element: <Login />, breadcrumb: "உள் நுழைவு" },
  { path: "/auth/login/awaiting-link", element: <LoginAwaitingLink />, breadcrumb: "உள்நுழைவு இணைப்பிற்காக காத்திருக்கிறது" },
  { path: "/register", element: <Login />, breadcrumb: "பதிவு" },
  { path: "/auth/signup", element: <Login />, breadcrumb: "இணைப்பு சரிபார்ப்பு" },
  { path: "/auth/signup/verify", element: <SignUpVerify />, breadcrumb: "இணைப்பு சரிபார்ப்பு" },
  { path: "/auth/password", element: <Login />, breadcrumb: "கடவுச்சொல் சரிபார்ப்பு" },
  { path: "/auth/password/verify", element: <PasswordVerify />, breadcrumb: "கடவுச்சொல் சரிபார்ப்பு" },
  { path: "/__/auth/action", element: <SignUpVerify />, breadcrumb: "சரிபார்ப்பு" },
  { path: "/auth/logout", element: <Logout />, breadcrumb: "வெளியேறு" },

  { path: "/user", element: <UserProfileHome />, breadcrumb: "பயனர் விவரம்" },
  { path: "/user/profile", element: <UserProfileHome />, breadcrumb: "பயனர் விவரம்" },
  { path: "/user/inbox", element: <UserInbox />, breadcrumb: "உங்கள் செய்திகள்" },
  { path: "/user/mobile-verification", element: <UserMobileVerification />, breadcrumb: "மொபைல் உறுதிப்படுத்தல்" },
  { path: "/user/set-profile-password", element: <UserProfileSetPassword />, breadcrumb: "கடவுச்சொல்லை அமைக்கவும்" },
  //{ path: "/user-address/update", element: <UserAddressUpdate /> },

  { path: "/user/donations", element: <UserDonations />, breadcrumb: "நன்கொடை விவரங்கள்" },
  { path: "/user/family", element: <UserFamily />, breadcrumb: "குடும்ப விவரங்கள்" },

  { path: "/user/family/create", element: <UserFamilyCreate />, breadcrumb: "பயனர் குடும்பம் உருவாக்கு" },
  { path: "/user/family/update/:id", element: <UserFamilyUpdate />, breadcrumb: "பயனர் குடும்பம் மேம்பாடு" },
  { path: "/user/family/view/:id", element: <UserFamilyView />, breadcrumb: "பயனர் குடும்பம் பார்க்க" },
  { path: "/user/family/address-update/:id", element: <UserFamilyAddressUpdate />, breadcrumb: "பயனர் குடும்ப முகவரி மேம்பாடு" },

  { path: "/user/family/member-create/:familyId", element: <UserFamilyMemberCreate />, breadcrumb: "பயனர் குடும்ப உறுப்பினர் உருவாக்கு" },
  { path: "/user/family/member-update/:id", element: <UserFamilyMemberUpdate />, breadcrumb: "பயனர் குடும்ப உறுப்பினர் மேம்பாடு" },
  { path: "/user/family/member-view/:id", element: <UserFamilyMemberView />, breadcrumb: "பயனர் குடும்ப உறுப்பினர் பார்க்க" },

  { path: "/event", element: <CalendarEvents />, breadcrumb: "நிகழ்வு நாட்காட்டி" },
  { path: "/event/calendar", element: <CalendarEvents />, breadcrumb: "நிகழ்வு நாட்காட்டி" },
  { path: "/event/admin", element: <AdminCalendar />, breadcrumb: "நிகழ்வு நிர்வாகி" },

  { path: "/address/admin", element: <AddressAdmin />, breadcrumb: "முகவரி நிர்வாகி" },
  { path: "/address-area/create", element: <AddressAreaCreate />, breadcrumb: "முகவரி பகுதி உருவாக்கு" },
  { path: "/address-area/update/:pincode", element: <AddressAreaUpdate />, breadcrumb: "முகவரி பகுதி மேம்பாடு" },
  { path: "/address-sub-area/update/:pincode", element: <AddressSubAreaUpdate />, breadcrumb: "துணை பகுதி மேம்பாடு" },
  { path: "/address-area/view/:pincode", element: <AddressAreaView />, breadcrumb: "முகவரி பகுதி பார்க்க" },

  { path: "/family", element: <FamilyAdmin />, breadcrumb: "குடும்ப நிர்வாகி" },
  { path: "/family/address-update/:id", element: <FamilyAddressUpdate />, breadcrumb: "குடும்ப முகவரி மேம்பாடு" },
  { path: "/family/create", element: <FamilyCreate />, breadcrumb: "குடும்பம் உருவாக்கு" },
  { path: "/family/update/:id", element: <FamilyUpdate />, breadcrumb: "குடும்பம் மேம்பாடு" },
  { path: "/family/view/:id", element: <FamilyView />, breadcrumb: "குடும்பம் பார்க்க" },
  { path: "/family/activate/:id", element: <FamilyActivate />, breadcrumb: "குடும்பம் செயல்படுத்து" },

  { path: "/family/member-create/:familyId", element: <FamilyMemberCreate />, breadcrumb: "குடும்ப உறுப்பினர் உருவாக்கு" },
  { path: "/family/member-activate/:id", element: <FamilyMemberActivate />, breadcrumb: "குடும்ப உறுப்பினர் செயல்படுத்து" },
  { path: "/family/member-bulk-move/:id", element: <BulkMoveFamilyMembers />, breadcrumb: "கூட்டமாக மாற்று" },
  { path: "/family/member-update/:id", element: <FamilyMemberUpdate />, breadcrumb: "குடும்ப உறுப்பினர் மேம்பாடு" },
  { path: "/family/member-view/:id", element: <FamilyMemberView />, breadcrumb: "குடும்ப உறுப்பினர் பார்க்க" },

  { path: "/contactus", element: <ContactUs />, breadcrumb: "தொடர்பு கொள்ள" },
  { path: "/privacy-policy", element: <PrivacyPolicy />, breadcrumb: "தனியுரிமைக் கொள்கை" },

  { path: "/history", element: <VelalarKudiyetram />, breadcrumb: "வரலாறு" },
  { path: "/history/VelalarKudiyetram", element: <VelalarKudiyetram />, breadcrumb: "வேளாளர் குடியெற்றம்" },
  { path: "/history/Kongunadu", element: <Kongunadu />, breadcrumb: "கொங்குநாடு" },
  { path: "/history/Arayanadu", element: <Arayanadu />, breadcrumb: "ஆராயநாடு" },
  { path: "/history/Kanjimanadhi", element: <Kanjimanadhi />, breadcrumb: "கஞ்சிமாநதி" },
  { path: "/history/VithariAthipalayam", element: <VithariAthipalayam />, breadcrumb: "வித்தரி ஆத்திப்பாளையம்" },
  { path: "/history/Ponnachiamman", element: <Ponnachiamman />, breadcrumb: "பொன்னச்சியம்மன்" },
  { path: "/history/PonnachiammanTempleAndFunction", element: <PonnachiammanTempleAndFunction />, breadcrumb: "பொன்னச்சியம்மன் கோயிலும் நிகழ்ச்சியும்" },
  { path: "/history/SembuthanKulam", element: <SembuthanKulam />, breadcrumb: "செம்புத்தான் குளம்" },
  { path: "/history/SembuthanKulamKaneyurgal", element: <SembuthanKulamKaneyurgal />, breadcrumb: "செம்புத்தான் குளம் கனையுர்கள்" },
  { path: "/history/KonguAvanangalilSembuthankulam", element: <KonguAvanangalilSembuthankulam />, breadcrumb: "கொங்கு அவணங்களில் செம்புத்தான் குளம்" },
  { path: "/history/SembuthanKulamKalvettukal", element: <SembuthanKulamKalvettukal />, breadcrumb: "செம்புத்தான் குளம் கல்வெட்டுக்கள்" },
  { path: "/history/SembuthanKulaManikki", element: <SembuthanKulaManikki />, breadcrumb: "செம்புத்தான் குல மணிக்கி" },
  { path: "/history/PugalpadiyaPulavargal", element: <PugalpadiyaPulavargal />, breadcrumb: "புகற்படிய புலவர்கள்" },
  { path: "/history/Kulakurukkal", element: <Kulakurukkal />, breadcrumb: "குளக்குறுக்கல்" },
  { path: "/history/PonnachiAmmanUnjalPattu", element: <PonnachiAmmanUnjalPattu />, breadcrumb: "பொன்னச்சி அம்மன் உஞ்சல் பாட்டு" },
  { path: "/history/SattrukaviValthupa", element: <SattrukaviValthupa />, breadcrumb: "சற்றுகவி வல்துபா" },
  { path: "/history/PonnachiammanPugalmalai", element: <PonnachiammanPugalmalai />, breadcrumb: "பொன்னச்சியம்மன் புகழ்மாலை" },

  { path: "/kudamulukku", element: <Kudamulukku2017ThanksNote />, breadcrumb: "குடமுளுக்கு" },
  { path: "/kudamulukku/Kudamulukku2017ThanksNote", element: <Kudamulukku2017ThanksNote />, breadcrumb: "குடமுளுக்கு 2017 நன்றி குறிப்பு" },

  //{ path: "/content/blog", element: <ExternalBlog />, breadcrumb: "வலைப்பதிவு" },
  { path: "/qr-code", element: <GenerateQRCode />, breadcrumb: "QR குறியீடு" },

  { path: "/config", element: <CategoryAdmin />, breadcrumb: "Config" },
  { path: "/config/category", element: <CategoryAdmin />, breadcrumb: "வகை நிர்வாகி" },

  { path: "/donation", element: <DonationAdmin />, breadcrumb: "தானம் நிர்வாகி" },
  { path: "/donation/create", element: <DonationCreate />, breadcrumb: "தானம் உருவாக்கு" },
  { path: "/donation/createEvent", element: <EventDonationCreate />, breadcrumb: "நிகழ்வு தானம் உருவாக்கு" },
  { path: "/donation/view/:id", element: <DonationView />, breadcrumb: "தானம் பார்க்க" },

  { path: "/expense", element: <ExpensesAdmin />, breadcrumb: "செலவுகள் நிர்வாகம்" },
  { path: "/expense/create", element: <ExpenseCreate />, breadcrumb: "செலவு உருவாக்கு" },
  { path: "/expense/view", element: <ExpenseView />, breadcrumb: "செலவைக் காண்" },
  { path: "/expense/search", element: <ExpensesSearch />, breadcrumb: "செலவுகள் தேடல்" },

  { path: "/contact", element: <ContactAdmin />, breadcrumb: "contact" },
  { path: "/contact/bulk-sms-send", element: <BulkSmsSend />, breadcrumb: "bulk-sms-send" },
  { path: "/contact/bulk-sms-delivery-check", element: <BulkSmsDeliveryCheck />, breadcrumb: "bulk-sms-delivery-check" },
  { path: "/contact/bulk-update-mobile-status", element: <BulkMobileStatusUpdate />, breadcrumb: "bulk-update-mobile-status" },


  { path: "*", element: <Home /> }, // Catch-all route
];

export default routesConfig;